export var DEFAULT_LIMIT = 100;
export var PREVIEW_EVENTS_LIMIT = 100000;
export var HIDE_TIME = 3000;